/**
 * Projects data for the portfolio section
 * This file imports the default projects and implements localStorage persistence
 */

import defaultProjectsData from './defaultProjects';

// Try to load projects from localStorage if available, otherwise use defaultProjects.js data
let projectsData = defaultProjectsData;

// Only run this code in browser environments (not during server-side rendering)
if (typeof window !== 'undefined') {
  try {
    const savedProjects = localStorage.getItem('projectsData');
    if (savedProjects) {
      projectsData = JSON.parse(savedProjects);
    }
  } catch (error) {
    console.error('Failed to load projects from localStorage:', error);
  }
}

export default projectsData; 